import { AuthenticationService } from './authService';
import { 
  getCurrentUserFromLocalStorage,
  getCurrencyFromLocalStorage,
  setCurrencyInLocalStorage
} from '../helpers/localStorageHelper';

let defaultCurrency = '';

/**
 * Currency Initialization Service
 * Handles currency detection and persistence
 */
export class CurrencyInitializationService {
  /**
   * Initialize with server-provided data
   */
  initialize(props = {}) {
    defaultCurrency = props.defaultCurrency || '';
  }

  /**
   * Check if user is logged in
   */
  isUserLoggedIn() {
    try {
      const currentUser = AuthenticationService.instance().getCurrentUser();
      return !!currentUser;
    } catch {
      return false;
    }
  }

  /**
   * Get currency for logged-in user
   */
  getLoggedInUserCurrency() {
    try {
      const currentUser = AuthenticationService.instance().getCurrentUser();
      if (currentUser?.currency) return currentUser.currency;
    } catch {}

    try {
      return getCurrentUserFromLocalStorage()?.currency || null;
    } catch {
      return null;
    }
  }


  /**
   * Currency selection logic for logged-in users
   */
  getCurrencyForLoggedInUser() {
    const userCurrency = this.getLoggedInUserCurrency();
    if (userCurrency) return userCurrency;
    return defaultCurrency || '';
  }

  /**
   * Currency selection logic for non-logged-in users
   */
  getCurrencyForNonLoggedInUser() {
    try {
      const storedCurrency = getCurrencyFromLocalStorage();
      if (storedCurrency) return storedCurrency;
    } catch {}
    
    return defaultCurrency || '';
  }

  /**
   * Sync localStorage currency with user currency if they differ
   */
  syncLocalStorage(currency) {
    try {
      const storedCurrency = getCurrencyFromLocalStorage();
      if (storedCurrency !== currency) {
        setCurrencyInLocalStorage(currency, { explicit: true });
      }
    } catch (err) {
      // silent fail
    }
  }

  /**
   * Handle currency initialization for non-logged-in users
   */
  handleNonLogin() {
    const currency = this.getCurrencyForNonLoggedInUser();
    this.syncLocalStorage(currency);
    return currency;
  }

  /**
   * Handle currency initialization for logged-in users
   */
  handleLogin() {
    const currency = this.getCurrencyForLoggedInUser();
    this.syncLocalStorage(currency);
    return currency;
  }

  /**
   * Main execution
   */
  async execute() {     
    if (this.isUserLoggedIn()) {
      return this.handleLogin();
    } else {
      return this.handleNonLogin();
    }
  }
}   